import React, {FC} from "react";
import {useAppDispatch, useAppSelector} from "../../../../../hooks/redux";
import style from "./LanguageSelect.module.css";
import {appSlice} from "../../../../../store/reducers/AppSlice";
import {EnumLanguage} from "../../../../../enums/EnumLanguage";
import {getLanguage} from "../../../../../store/selectors/appSelector";
import clsx from "clsx";

export const LanguageSelect: FC = () => {

    const dispatch = useAppDispatch()
    const currentLanguage = useAppSelector(getLanguage)

    const listLanguage = Object.values(EnumLanguage)

    return (
        <ul className={style.languageSelectWrapper}>

            {listLanguage.map(language => {
                return (
                    <li key={language} className={clsx(language === currentLanguage && style.selectedLanguage)}
                        onClick={() => dispatch(appSlice.actions.chooseLanguage(language))}>
                        {language.toUpperCase()}
                    </li>
                )
            })}

        </ul>
    )


}